import { render, staticRenderFns } from "./OldUploader.vue?vue&type=template&id=149e60fc&"
import script from "./OldUploader.vue?vue&type=script&lang=js&"
export * from "./OldUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports